<template>
  <div class="img-caption-processed" ref="container">
    <resize-observer @notify="onResize" />
    <div class="image" :style="styleObj">
      <!-- [tmp-src] quick fix for photo slider -->
      <img v-lazy="imageUrl" :class="imageClass" :data-style-type="imageDataStyleType" :tmp-src="imageUrl" :data-writer="imageDataWriter" :height="imageHeight" :width="imageWidth" :title="imageTitle" ref="lazyload"/>
    </div>
    <div v-if="type === 'photo-essay'" class="photo-share">
      <share-buttons :url="shareUrl"
                     :title="imageTitle || shareData.title"
                     :thumbnail="shareThumbnail"
                     :avaliableIcons="{pinterest: true, email: false, whatsapp: false, messenger: false}"
      ></share-buttons>
    </div>
    <figcaption v-if="imageTitle.length > 0">{{imageTitle}}</figcaption>
  </div>
</template>

<script>
  import get from 'lodash/get'
  import head from 'lodash/head'
  import { isDesktop } from 'mixins/utilities'
  import { ResizeObserver } from 'vue-resize'

  import ShareButtons from 'components/widgets/ShareButtons.vue'

  export default {
    name: 'body-image',
    props: ['item', 'type', 'shareData', 'itemIndex', 'inlinePhotoList'],
    data() {
      return {
        imageWrapperHeight: 0,
      }
    },
    components: {
      ResizeObserver,
      ShareButtons,
    },
    mounted() {
      this.$Lazyload.$on('loaded', ({ el }) => {
        if (el === this.$refs.lazyload) {
          this.imageWrapperHeight = 0
        }
      })
      this.calculateWrapperHeight()
    },
    methods: {
      calculateWrapperHeight() {
        if (this.imageHeight > 0 && this.imageWidth > 0 && this.$refs.container.offsetWidth > 0) {
          if (isDesktop()) {
            this.imageWrapperHeight = `calc( (${this.$refs.container.offsetWidth}px) * (${this.imageHeight / this.imageWidth}))`
          } else {
            this.imageWrapperHeight = `calc( 100vw * (${this.imageHeight / this.imageWidth}))`
          }
        }
      },
      onResize() {
        this.calculateWrapperHeight()
      },
    },
    computed: {
      styleObj() {
        const output = {}
        if (this.imageWrapperHeight) {
          output.height = this.imageWrapperHeight
        }
        return output
      },
      shareUrl() {
        return get(this, `inlinePhotoList[${(this.itemIndex - 1)}][sizes].style_700x400`) ? `${this.shareData.url}/photo/${this.itemIndex}` : this.shareData.url
      },
      shareThumbnail() {
        return get(this, `inlinePhotoList[${(this.itemIndex - 1)}][sizes].style_700x400`)
      },
      imageAttribs() {
        return get(this, 'item.content.attribs', {})
      },
      imageStyle() {
        return get(this, 'imageAttribs.style', '')
      },
      imageUrl() {
        return get(this, 'imageAttribs.src', '')
      },
      imageHeight() {
        let height = get(this, 'imageAttribs.height', '').replace(/px/g, '')
        if (height.length === 0 && this.imageStyle.length > 0) {
          // get height form style
          const styleHeight = head(this.imageStyle.match(/height(.*?)px;/g))
          if (styleHeight.length > 0) height = styleHeight.match(/\d/g).join('')
        }
        return height
      },
      imageWidth() {
        let width = get(this, 'imageAttribs.width', '').replace(/px/g, '')
        if (width.length === 0 && this.imageStyle.length > 0) {
          // get width form style
          const styleWidth = head(this.imageStyle.match(/width(.*?)px;/g))
          if (styleWidth.length > 0) width = styleWidth.match(/\d/g).join('')
        }
        return width
      },
      imageClass() {
        return get(this, 'imageAttribs.class', '')
      },
      imageDataStyleType() {
        return get(this, 'imageAttribs[\'data-style-type\']', '')
      },
      imageDataWriter() {
        return get(this, 'imageAttribs[\'data-writer\']', '')
      },
      imageTitle() {
        return get(this, 'imageAttribs.title', '')
      },
    },
  }
</script>

<style lang="scss" scoped>
  .img-caption-processed{
    .image {
      background-color: $cadet-blue-2;
      background-clip:content-box;
    }

    img:hover, img:focus {
      -webkit-filter: $image-hover-opacity;
    }

    @include respond-to('desktop'){
      margin-top: rem-calc(40);
      margin-bottom: rem-calc(40);
    }

    @include respond-to('mobile'){
      padding-bottom: rem-calc(12);
    }

    .photo-share {
      padding-top: rem-calc(20);
      @include respond-to('mobile'){
        padding-top: rem-calc(16);
        margin: rem-calc(0 27);
      }
      /deep/ .share-button-container.mode-inline .share-buttons-wrapper{
        width: 0;
        a {
          padding-right: rem-calc(20);
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Image.vue?d1efe854